var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cog-settings-24-outlined"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 56.6667C34.6759 56.6667 28.3333 50.324 28.3333 42.5C28.3333 34.676 34.6759 28.3333 42.5 28.3333C50.324 28.3333 56.6666 34.676 56.6666 42.5C56.6666 50.324 50.324 56.6667 42.5 56.6667ZM49.5833 42.5C49.5833 46.412 46.412 49.5833 42.5 49.5833C38.5879 49.5833 35.4166 46.412 35.4166 42.5C35.4166 38.588 38.5879 35.4167 42.5 35.4167C46.412 35.4167 49.5833 38.588 49.5833 42.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0739 74.0103L73.9264 66.1578L71.1608 56.1106L72.3657 53.233L81.4583 48.1023V36.9978L72.3915 31.8457L71.2068 28.9732L74.0071 18.9208L66.1491 11.0742L56.101 13.839L53.2299 12.6352L48.0987 3.54167H36.9942L31.8421 12.6085L28.9703 13.7929L18.9195 10.9891L11.0737 18.8349L13.8389 28.8847L12.6351 31.7558L3.54163 36.887V47.9882L12.6003 53.1518L13.786 56.0268L10.9861 66.0775L18.8349 73.9263L28.8846 71.161L31.7561 72.365L36.8874 81.4548H47.989L53.1488 72.3959L56.0232 71.2104L66.0739 74.0103ZM66.7698 48.2574L63.6822 55.6316L66.0032 64.0637L63.9901 66.0767L55.5759 63.7328L48.1984 66.7754L43.8718 74.3714H41.0228L36.732 66.7705L29.3659 63.682L20.9293 66.0034L18.9196 63.9937L21.2636 55.5795L18.2212 48.2026L10.625 43.8726V41.0233L18.2293 36.7324L21.3179 29.3659L18.9966 20.9294L21.0021 18.9239L29.4162 21.2711L36.7963 18.2274L41.1162 10.625H43.9624L48.2533 18.2293L55.6197 21.318L64.058 18.9962L66.0727 21.008L63.7292 29.4205L66.7726 36.7999L74.375 41.1199V43.966L66.7698 48.2574Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.df29f634738343c152285caf60b7d1bf.svg";
export { ForwardRef as ReactComponent };